export const credentialingEncryptionKeyName = 'credentialingEncryptionKey';
export function encryptData(context, data, errorMessage) {
    var _a;
    const encryptedData = context.encryption.encrypt(data, credentialingEncryptionKeyName, {
        algorithm: 'AES_GCM',
        ivLength: 128,
    });
    if (!encryptedData) {
        throw new Error(errorMessage);
    }
    return encryptedData.encryptedData + ':' + ((_a = encryptedData.metadata) === null || _a === void 0 ? void 0 : _a.IV);
}
export function decryptData(context, encryptedData, errorMessage) {
    const data = encryptedData.split(':');
    const decryptedData = context.encryption.decrypt(data[0], credentialingEncryptionKeyName, {
        algorithm: 'AES_GCM',
        IV: data[1],
    });
    if (!decryptedData) {
        throw new Error(errorMessage);
    }
    return decryptedData.decryptedData;
}
